import dkAxios from '@/jslib/dk-axios'

export const getOrderList = data => dkAxios({
  url: '/cms/Order',
  method: 'GET',
  params: data,
});

export const getOrderDetail = data => dkAxios({
  url: `/cms/Order/${data}`,
  method: 'GET',
});

export const closeRefundOrder = data => dkAxios({
  url: '/cms/Order/refund',
  method: 'POST',
  data,
});

export const closeCancelOrder = data => dkAxios({
  url: '/cms/Order/cancel',
  method: 'POST',
  data,
});

export const offlinePayOrder = data => dkAxios({
  url: '/cms/Order/offlinePay',
  method: 'POST',
  data,
});

export const confirmOrder = data => dkAxios({
  url: '/cms/Order/confirm',
  method: 'POST',
  data,
});

export const deliveryOrder = data => dkAxios({
  url: '/cms/Order/ship',
  method: 'POST',
  data,
});

export const chengMoney = data => dkAxios({
  url: `/cms/Order/${data.uuid}`,
  method: 'PUT',
  data,
});

export const getPointOrderList = data => dkAxios({
  url: '/cms/PointOrder',
  method: 'GET',
  params: data,
});

export const getPointOrderDetail = data => dkAxios({
  url: `/cms/PointOrder/${data}`,
  method: 'GET',
});

export const closeRefundPointOrder = data => dkAxios({
  url: '/cms/PointOrder/refund',
  method: 'POST',
  data,
});

export const confirmPointOrder = data => dkAxios({
  url: '/cms/PointOrder/confirm',
  method: 'POST',
  data,
});

export const deliveryPointOrder = data => dkAxios({
  url: '/cms/PointOrder/ship',
  method: 'POST',
  data,
});

export const getExportUrl = data => dkAxios({
  url: '/cms/Order/export',
  method: 'GET',
  params: data,
});


export const getExportUrlPoint = data => dkAxios({
  url: '/cms/PointOrder/export',
  method: 'GET',
  params: data,
});



// WEBPACK FOOTER //
// ./src/api/order.js